export default __webpack_public_path__ + "static/media/HillsHaveEyes.a661ed23.mp3";